module.exports = __webpack_public_path__ + "img/LogoVEQ_Color.0afaa0b2.png";